import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import AdminUserInfo from "@/components/admin/admin-user-info";

const AdminUserInfoPage = (): JSX.Element => {
	const { userId } = Route.useParams();
	return <AdminUserInfo userId={userId} />;
};

export const Route = createFileRoute("/_app/admin/users/$userId/")({
	component: AdminUserInfoPage,
});
